import React, { useRef } from 'react';
import { CheckCircle2, Upload, Sparkles, User, Camera, Plus, Trash2 } from 'lucide-react';

export function MultiAngleAvatarCard({
  avatarSrc,
  avatarName = 'Mi Avatar Personal',
  angles = [],
  onAvatarChange,
  onAddAngle,
  onRemoveAngle,
  onOpenScanner
}) {
  const fileInputRef = useRef(null);
  const angleInputRef = useRef(null);

  const handlePrimaryChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onAvatarChange) {
      const reader = new FileReader();
      reader.onload = (uploadEvent) => {
        onAvatarChange(uploadEvent.target?.result, file.name);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAngleUpload = (e) => {
    const file = e.target.files?.[0];
    if (file && onAddAngle) {
      const reader = new FileReader();
      reader.onload = (uploadEvent) => {
        onAddAngle(uploadEvent.target?.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={{
      padding: '14px',
      background: 'linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 100%)',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.08)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <span style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Sparkles size={13} color="#c084fc" /> Identidad Facial Multi-Ángulo
        </span>
        <span style={{ fontSize: '11px', color: '#10b981', display: 'flex', alignItems: 'center', gap: '4px', background: 'rgba(16,185,129,0.1)', padding: '2px 7px', borderRadius: '12px' }}>
          <CheckCircle2 size={12} /> {1 + angles.length} Ángulo{angles.length > 0 ? 's' : ''} Fijado{angles.length > 0 ? 's' : ''}
        </span>
      </div>

      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => fileInputRef.current?.click()} title="Foto Principal (Frente)">
          <img
            src={avatarSrc}
            alt={avatarName}
            style={{ width: '58px', height: '58px', borderRadius: '10px', objectFit: 'cover', border: '1.5px solid rgba(192,132,252,0.6)' }}
          />
          <div style={{
            position: 'absolute',
            bottom: '-4px',
            right: '-4px',
            background: '#a855f7',
            borderRadius: '50%',
            width: '18px',
            height: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: '9px',
            fontWeight: 800
          }}>
            1
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: '#f1f5f9' }}>{avatarName}</div>
          <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>Embedding facial 3D activo</div>

          <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: '#e2e8f0',
                borderRadius: '6px',
                padding: '3px 7px',
                fontSize: '10px',
                fontWeight: 500,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <Upload size={11} /> Frente
            </button>

            <button
              type="button"
              onClick={() => angleInputRef.current?.click()}
              style={{
                background: 'rgba(168,85,247,0.12)',
                border: '1px solid rgba(192,132,252,0.4)',
                color: '#c084fc',
                borderRadius: '6px',
                padding: '3px 7px',
                fontSize: '10px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <Plus size={11} /> + Foto
            </button>

            {onOpenScanner && (
              <button
                type="button"
                onClick={onOpenScanner}
                style={{
                  background: 'linear-gradient(135deg, rgba(255,145,1,0.2), rgba(168,85,247,0.2))',
                  border: '1px solid rgba(255,145,1,0.5)',
                  color: '#ff9101',
                  borderRadius: '6px',
                  padding: '3px 8px',
                  fontSize: '10px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <Camera size={11} /> Escáner 3D / QR
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Tira de Ángulos Adicionales */}
      {angles.length > 0 && (
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', overflowX: 'auto', paddingBottom: '4px' }}>
          {angles.map((angSrc, idx) => (
            <div key={idx} style={{ position: 'relative', flexShrink: 0 }}>
              <img
                src={angSrc}
                alt={`Ángulo ${idx + 2}`}
                style={{ width: '40px', height: '40px', borderRadius: '6px', objectFit: 'cover', border: '1px solid rgba(255,255,255,0.15)' }}
              />
              <button
                type="button"
                onClick={() => onRemoveAngle && onRemoveAngle(idx)}
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  background: 'rgba(239, 68, 68, 0.9)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '14px',
                  height: '14px',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '8px'
                }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <input ref={fileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePrimaryChange} />
      <input ref={angleInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleAngleUpload} />
    </div>
  );
}
